import { render, staticRenderFns } from "./ContactCreateUpdate2.vue?vue&type=template&id=3b8f96a1&scoped=true&"
import script from "./ContactCreateUpdate2.vue?vue&type=script&lang=js&"
export * from "./ContactCreateUpdate2.vue?vue&type=script&lang=js&"
import style0 from "./ContactCreateUpdate2.vue?vue&type=style&index=0&id=3b8f96a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f96a1",
  null
  
)

export default component.exports